import themeBreakpoints from './breakpoints';
import themeIndents from './indents';
import borderRadii from './radii';
import { TTheme } from './types';
import themeHeaders from './typography.headers';
import themeText from './typography.paragraphs';

const commonTheme: Omit<TTheme, 'colors'> = {
    typography: {
        headers: themeHeaders,
        text: themeText,
    },
    indents: themeIndents,
    breakpoints: themeBreakpoints,
    radii: borderRadii,
};

export default commonTheme;
